import { Flex, FormGroup, FormRadio, Text } from '@spotify-internal/encore-web';

import { useAccountDetailsContext } from './CreateAccountFormProvider';
import { Region } from './hooks/useCreateAccount';

export const RegionSection = () => {
  const { accountDetails, handleRegionChange } = useAccountDetailsContext();

  return (
    <Flex direction="column" gap="tighter-2">
      <Text variant="bodyMedium" semanticColor="textSubdued">
        Choose where your data is stored to comply with data regulations. This
        can&apos;t be changed later. If unsure, select EU.
      </Text>
      <FormGroup label="Data region" hideLabel withFieldset>
        <FormRadio
          id="region-eu"
          name="region"
          value={Region.RegionEu}
          checked={accountDetails.region === Region.RegionEu}
          onChange={() => handleRegionChange(Region.RegionEu)}
         data-track-source-anchor="788eb44f4e">
          EU
        </FormRadio>
        <FormRadio
          id="region-us"
          name="region"
          value={Region.RegionUs}
          checked={accountDetails.region === Region.RegionUs}
          onChange={() => handleRegionChange(Region.RegionUs)}
         data-track-source-anchor="0f6b86f07a">
          US
        </FormRadio>
      </FormGroup>
    </Flex>
  );
};
